<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/about/facilities',
    'fr-CA': '/a-propos-kpt/usines'
  }
})

useHead({
  title: t('navigation.facilities.metatitle'),
  meta: [{ name: 'description', content: t('navigation.facilities.metadescription') }]
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('about-about')">{{ $t('navigation.about.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.facilities.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.facilities.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuAbout />
        <div class="contenu right">
          <div v-if="$i18n.locale == 'en-CA'"
               class="">
            <p>Kruger Products Inc. &nbsp;is headquartered in Mississauga, Ontario and has approximately 3,000 employees across Canada and the United States. Kruger Products Inc. operates a total of ten FSC® COC-certified (FSC®-C104904) production facilities, including six plants, five of which are located in Canada and one in the U.S. Three of the production facilities are converting only.</p>
            <p>Kruger Products Inc.’s Canadian paper manufacturing facilities, consisting of four tissue plants in Québec and one plant in British Columbia, have a combined annual tissue production capacity of approximately 350,000 metric tonnes which, according to RISI data, represents approximately 44% of Canada’s annual production capacity. The new TAD paper machine was successfully started up at the end of January 2021 with an aggregate annual capacity of 70,000 metric tonnes at maturity.</p>
            <p id="ID1486674827079">
Kruger Products Inc.’s &nbsp;Memphis Plant, held through KTG, a wholly-owned subsidiary, consists of one conventional light dry crepe paper machine&nbsp;with an aggregate annual capacity of 30,000 metric tonnes, and one adjacent 55,000 metric tonne state-of-the-art TAD paper machine.
</p>
            <p>
<a name="hyperlien"
                 href="/documents/KPT_Facilities_2024_ENG.pdf"
                 target="_blank">Click here</a> for more information about our facilities and network.
</p>
          </div>
          <div v-if="$i18n.locale == 'fr-CA'"
               class="">
            <p>Produits Kruger inc. a son siège social à Mississauga, en Ontario, et emploie environ 3 000 personnes au Canada et aux États-Unis. Au total, Produits Kruger inc. exploite dix installations de production certifiées FSCMD COC (FSCMD-C104904), dont six usines (cinq situées au Canada et une aux États-Unis). Trois des installations de production ne font que de la transformation.</p>
            <p>Les installations canadiennes de fabrication de papier de Produits Kruger inc., qui comprennent quatre usines de papier tissu au Québec et une usine en Colombie-Britannique, ont une capacité de production annuelle combinée de papier tissu d'environ 350 000 tonnes métriques, ce qui, selon les données de RISI, représente environ 44 % de la capacité de production annuelle du Canada. La nouvelle machine à papier TAD a été mise en service avec succès à la fin de janvier 2021, avec une capacité annuelle globale de 70 000 tonnes métriques à maturité.&nbsp;</p>
            <p id="ID1486674827079">
L'usine de Produits Kruger inc. à Memphis, détenue par l'entremise de KTG, une filiale en propriété exclusive, comprend une machine&nbsp;à papier crêpé sec léger conventionnel d'une capacité annuelle globale de 30 000 tonnes métriques, et une machine à papier TAD adjacente de 55 000 tonnes métriques à la fine pointe de la technologie.
</p>
            <p>
<a name="hyperlien"
                 href="/documents/KPT_Facilities_2024_FR.pdf"
                 target="_blank">Cliquez ici</a> pour en savoir plus sur nos installations et notre réseau.
</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
